import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || "https://staging-api.kingdynasty.com.au";
axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";

export default axios;